import React from "react";
import { motion } from "framer-motion";
import { BENCHMARKS } from "../../data/assessment";

export default function Benchmarks() {
  return (
    <section
      className="w-full"
      style={{ backgroundColor: "var(--rtd-card)", padding: "80px 24px" }}
      data-testid="benchmarks-section"
    >
      <div className="mx-auto" style={{ maxWidth: 680 }}>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          style={{ marginBottom: 40 }}
        >
          <p className="eyebrow" style={{ marginBottom: 12 }}>
            Industry Benchmarks
          </p>
          <h2
            className="font-serif-display"
            style={{ fontSize: 32, color: "var(--rtd-text)", lineHeight: 1.15 }}
          >
            What the gap looks like in numbers.
          </h2>
          <p
            className="font-body"
            style={{ fontSize: 16, color: "var(--rtd-text-secondary)", lineHeight: 1.7, marginTop: 12 }}
          >
            The difference between clinics running form-fill optimisation and clinics
            running CRM revenue feedback loops.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2" style={{ gap: 16 }}>
          {BENCHMARKS.map((b, i) => (
            <motion.div
              key={b.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 2) * 0.08 }}
              data-testid={`benchmark-card-${i + 1}`}
              className="text-center"
              style={{
                backgroundColor: "var(--rtd-card)",
                border: "1px solid var(--rtd-border)",
                borderRadius: 12,
                padding: 24,
              }}
            >
              <div
                className="font-serif-display"
                style={{ fontSize: 40, color: "var(--rtd-gold)", lineHeight: 1.05, marginBottom: 10 }}
              >
                {b.number}
              </div>
              <div
                className="font-body"
                style={{ fontSize: 13, color: "var(--rtd-text-secondary)", lineHeight: 1.5, marginBottom: 10 }}
              >
                {b.label}
              </div>
              <div className="font-body" style={{ fontSize: 11, color: "var(--rtd-muted)" }}>
                {b.source}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
